import Http from "./http";

export const updateEmailTemplateAPI = (data, options) => {
  return Http.post("admin/email-templates/updateTemplate", data, options);
};
